
export default function CopyAssetDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,
  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  assetDataService,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleCopyAssetSubmit = _handleCopyAssetSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.customerAssetId = 0;
    _initEventListeners();
  }

  function _initEventListeners() {
  }

  function _handleCloseDialogClick() {
    _closeDialog();
  }

  function _handleCopyAssetSubmit() {
    if ($scope.copyAssetForm.$valid) {
      loaderService.showViewLoader = true;

      return assetDataService.copyAsset(vm.asset.customerAssetId, vm.name, vm.presetsNamePrefix).then(response => {
        loaderService.showViewLoader = false;
        if (!response.data) {
          alerts.error('An error occurred while copying the Asset.');
        } else {
          alerts.success('The Asset has been successfully copied.');
          if (vm.updateCallBack) {
            vm.updateCallBack();
          }
          _closeDialog();
        }
      });
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.copyAssetDialog);
  }
}

CopyAssetDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'assetDataService',
];
